import { Box, useTheme } from "@mui/material";
import { Camera, FolderOpen, Image, type LucideIcon } from "lucide-react";
import type { FC } from "react";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";
import { ListRow } from "web_myplann/Shared/Components/ListRow";
import type { AttachmentPicker } from "web_myplann/Shared/Types/AttachmentPicker";
import { device } from "web_myplann/Utils/device";

const R = Resources.Portfolio.List.AddDocumentDrawer.Types;

type DocumentSource = {
	key: string;
	icon: LucideIcon;
	scale: "orange" | "purple" | "blue";
	label: string;
	picker: AttachmentPicker;
};

const DOCUMENT_SOURCES: DocumentSource[] = [
	{
		key: "photo",
		icon: Camera,
		scale: "orange",
		label: R.photo,
		picker: device.pickAttachmentPhoto,
	},
	{
		key: "gallery",
		icon: Image,
		scale: "purple",
		label: R.gallery,
		picker: device.pickAttachmentGallery,
	},
	{
		key: "file",
		icon: FolderOpen,
		scale: "blue",
		label: R.file,
		picker: device.pickAttachmentFile,
	},
];

type Props = {
	disabled: boolean;
	onPick: (picker: AttachmentPicker) => void;
};

export const DocumentSourcePicker: FC<Props> = ({ disabled, onPick }) => {
	const { palette, iconSize } = useTheme();
	const { t } = useResource();

	return (
		<Box bgcolor={palette.background.paper}>
			{DOCUMENT_SOURCES.map(
				({ key, icon: Icon, scale, label, picker }, index) => (
					<ListRow
						key={key}
						icon={<Icon size={iconSize.md} color={palette[scale][600]} />}
						iconBg={palette[scale][100]}
						title={t(label)}
						disabled={disabled}
						onClick={() => onPick(picker)}
						isLast={index === DOCUMENT_SOURCES.length - 1}
					/>
				),
			)}
		</Box>
	);
};
